import { render, staticRenderFns } from "./TeachingRegister.vue?vue&type=template&id=2fef7a0e&scoped=true&"
import script from "./TeachingRegister.vue?vue&type=script&lang=js&"
export * from "./TeachingRegister.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fef7a0e",
  null
  
)

export default component.exports